import React from 'react';
import type { ChannelIntegrationEditorProps } from 'components/integrations/ChannelIntegrationEditor/ChannelIntegrationEditorProps';
import type { IntegrationPropertyType } from 'application-types';
import { FloorMapping } from './FloorMapping';

type KastleFloorMappingProps = {
  property: IntegrationPropertyType;
  value?: any;
  label?: string;
  onChange: (value: any) => void;
  channel: ChannelIntegrationEditorProps['channel'];
  settings: ChannelIntegrationEditorProps['channelIntegration']['settings'];
  metadataLoading?: boolean;
};

export const KastleFloorMapping = ({
  property,
  value,
  label,
  onChange,
  channel,
  settings,
  metadataLoading,
}: KastleFloorMappingProps) => {
  return (
    <FloorMapping
      property={property}
      value={value}
      label={label}
      onChange={onChange}
      channel={channel}
      settings={settings}
      metadataLoading={metadataLoading}
      floorKey="acsFloorId"
      sourceDisplayName="Activate"
      providerDisplayName="Kastle"
      providerFloorOptions={property?.acsFloorId || []}
    />
  );
};